<template>
  <div class="modal--wrapper" :class="{'modal-open': modalOpenState}">
    <div class="modal txt-modal">
      <div class="modal--title">
        <div class="modal--title-text">MiHotel</div>
        <div class="modal--title-actions">
          <modal-close-btn @click="closeModal" />
        </div>
      </div>
      <div class="modal--content" v-if="loading">
        <div class="loader">
          <loader/>
        </div>
      </div>
      <div class="modal--content" v-else-if="tab === 1">
        <div class="text-group" v-for="(item, index) in sales" :item="item" :key="index+item.title" :index="index">
          <h1 v-html="item.title"></h1>
          <div class="text-content" v-html="clearHtml(item.content)"></div>
        </div>
      </div>
      <div class="modal--content" v-else-if="tab === 0">
        <div class="text-group" v-for="(item, index) in legal" :item="item" :key="index+item.title" :index="index">
          <h1 v-html="item.title"></h1>
          <div class="text-content" v-html="clearHtml(item.content)"></div>
        </div>
      </div>
      <div class="modal--content" v-else>
        <p>aucun texte</p>
      </div>
    </div>
  </div>
</template>

<script>
  import loader from "./loader.component";
  import {mapState} from "vuex";
  import ModalCloseBtn from "./modal-close-btn";

  export default {
    name: "modal-texts",
    components: {ModalCloseBtn, loader},
    computed: {
      ...mapState({
        modalOpenState: s => s.legalModal.modalOpenState,
        loading: s => s.legalModal.loading,
        tab: s => s.legalModal.currentTab,
        legal: s => s.legalModal.termLegals,
        sales: s => s.legalModal.termOfSales,
      })
    },
    watch: {
      modalOpenState(v) {
        if (v && (this.legal.length === 0 || this.sales.length === 0)) {
          this.$store.dispatch('legalModal/fetch');
        }
      }
    },
    methods: {
      closeModal() {
        this.$store.commit('legalModal/CLOSE_MODAL');
      },
      clearHtml (v) {
        return v.replace(/(<[^>]+)width[^>]+>/gi, "$1>");
      }
    }
  }
</script>

<style scoped>
  .modal--content {
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
  }
  .loader {
    height: 120px;
  }

  .modal--title-actions {
    bottom: unset;
    top: -6px;
  }

</style>




// WEBPACK FOOTER //
// src/components/modal-texts.vue